// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__ISs2k","FontWeight-bold":"Label_FontWeight-bold__2aQQn","FontWeight-regular":"Label_FontWeight-regular__1LRIq"};